import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import VerificationPage from './components/VerificationPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/verification" element={<VerificationPage />} />
      </Routes>
    </Router>
  );
}

export default App;